import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-sidebar-nav-link',
    templateUrl: './sidebar-nav-link.component.html',
    styleUrls: ['./sidebar-nav-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarNavLinkComponent {
    @Input() externalLink: string;
    @Input() link: string;
    @Input() linkName: string;

    @Input() iconName: string;
    @Input() iconName2: string;

    @Input() tooltip: string;
    @Input() isNavbarOpen: boolean;

    // Determines if the SVG should be highlighted by changing stroke or fill CSS attribute
    @Input() highlightMode: 'stroke' | 'fill';
    @Input() removeSVGAttributes: string[];

    get isFillHighlightMode(): boolean {
        return this.highlightMode === 'fill';
    }

    get isStrokeHighlightMode(): boolean {
        return this.highlightMode === 'stroke';
    }
}
